/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionSupportingDocumentsQuery = gql`
  query GetSouscriptionSupportingDocumentsQuery {
    getSouscriptionSupportingDocuments_souscription_supporting_documents {
      projectId 
      projectStatus 
      signature {
 mode  
}
      maxFileSize 
      uploadedFileLimit 
      filesToUpload {
 label  
filesType  
files {
 uploadId  
fileName  
fileType  
required  
} 
required  
group {
 label  
filesType  
required  
files {
 uploadId  
fileName  
fileType  
required  
} 
informations  
} 
informations  
}
    }
  }
`;

export default GetSouscriptionSupportingDocumentsQuery;
